export const ua = {
  LANGUAGES: {
    English: 'Англійська',
    Russian: 'Російська',
    Ukrainian: 'Українська',
    German: 'Німецька',
  },
  PAGES: {
    CHAT_HISTORY: {
      YOUR_PREVIOUS_CONVERSATION: 'Ваші попередні розмови',
      SEARCH_BY_NAME: 'Пошук за назвою',
      PLACEHOLDER_TITLE: 'За вашим запитом нічого не знайдено',
      PLACEHOLDER_TEXT: 'Спробуйте змінити параметри пошуку',
      EMPTY: {
        TITLE: 'У вас поки немає активних чатів',
        TEXT: 'Оберіть пригоду з десятків тисяч або створіть власну',
        CREATE_CHATBOT: 'Створити чат-бота',
        GO_TO_CATALOG: 'Перейти до каталогу',
      },
    },
    SUBSCRIBE: {
      SUBSCRIBE: 'Підписка',
      PICK_THE_PLAN: 'Виберіть план або купіть токени',
      UPGRADE_YOUR_EXPERIENCE: 'Покращіть свій досвід і розкрийте уяву з преміум-функціями',
      BUY_TOKENS: 'Купити токени',
      APPLY: 'Застосувати',
      PROMOTIONAL_CODE: 'Промокод',
      COMPARE_CAICHAT_FEATURE: 'Порівняйте функції CAICHAT',
      NO_ADS: 'Без реклами',
      SKIP_QUEUES: 'Без черг',
      CONTEXTUAL_MEMORY_4K: "Контекстна пам'ять до 4K токенів (приблизно 42 повідомлення)",
      ACCESS_MEMORY_MANAGER: "Доступ до менеджера пам'яті",
      CUSTOM_PERSONAS_10: 'До 10 користувацьких персон',
      CONTEXTUAL_MEMORY_8K: "Контекстна пам'ять до 8K токенів (приблизно 84 повідомлення)",
      SEMANTIC_MEMORY_2: "Семантична пам'ять 2.0: автоматичне збереження та використання спогадів",
      EXTENDED_RESPONSES: 'Розширені відповіді до 300 токенів',
      IMAGE_GENERATION: 'Генерація зображень у діалозі',
      ACCESS_AI_MODELS: 'Доступ до додаткових моделей ШІ',
      CUSTOM_PERSONAS_50: 'До 50 користувацьких персон',
      CONTEXTUAL_MEMORY_16K: "Контекстна пам'ять до 16K токенів (приблизно 168 повідомлень)",
      PRIORITY_GENERATION: 'Пріоритет у генерації відповідей',
      ACCESS_ADVANCED_MODELS: 'Доступ до просунутих моделей ШІ',
      IMAGE_GENERATION_ALL: 'Генерація зображень для всіх персонажів, включно з приватними',
      TEXT_TO_SPEECH: 'Функція перетворення тексту в мовлення (голосові відповіді)',
      CUSTOM_PERSONAS_100: 'До 100 користувацьких персон',
    },
    MY_PROFILE: {
      MY_PROFILE: 'Мій профіль',
      SETTINGS: 'Налаштування',
      LOG_OUT: 'Вийти',
      TITLE: 'Тримайтеся міцніше!\nВаша особиста панель керування готується!',
      TEXT: 'Наша команда наполегливо працює над тим, щоб створити для вас надзвичайно зручний особистий кабінет.\nНезабаром ви зможете переглядати детальну статистику, відстежувати витрати та доходи, а також багато іншого.\nСлідкуйте за оновленнями!',
    },
    MY_PERSONAS: {
      PLACEHOLDER_1: 'У вас ще немає персона.',
      PLACEHOLDER_2: 'Створіть нову.',
      CREATE_PERSONA: 'Створити нову персону',
    },
    CREATE_PERSONA: {
      PERSONA: 'Персона',
      NAME_PLACEHOLDER: 'Будь ласка, введіть назву вашої персона',
      DESCRIPTION: 'Опис',
      DESCRIPTION_PLACEHOLDER: 'Як би ваш персонаж описав себе?',
      DESCRIPTION_INFO: 'Використовується лише у ваших розмовах для надання контексту ШІ. Будьте лаконічними (1-2 речення).',
      VISIBILITY: 'Видимість',
      PUBLIC: 'Публічна',
      PRIVATE: 'Приватна',
      CHECKBOX: 'Встановити як персону за замовчуванням',
      ALREADY_DEFAULT: 'Вже персона за замовчуванням',
      NAME: 'Назва',
      SUCCESSFULLY_CREATED: 'Персона успішно створена',
      SUCCESSFULLY_UPDATED: 'Персона успішно оновлена',
      NO_SPACE_FOR_NEW_PERSONAS: 'Ви не зможете створювати нових персон, поки не звільните місце',
    },
    MY_CHATBOTS: {
      NO_CHATBOTS: 'Ви ще не створили жодного чат-бота!',
      DO_IT_NOW: 'Зробіть це зараз!',
    },
    CHARACTERS: {
      NO_CHARACTERS: 'За вашим запитом нічого не знайдено',
      FILTERS: 'Спробуйте змінити параметри пошуку або створіть власного чатбота',
    },
    PUBLIC_PROFILE: {
      NO_CHATBOTS: 'У цього користувача наразі немає чатботів',
      TRY_LATTER: 'Спробуйте повернутися пізніше',
    },
    FAVORITES: {
      NO_FAVORITES: 'У вас поки немає чатботів у вибраному',
      GO_AND_ADD: 'Перейдіть до каталогу та додайте чатботів у вибране, натиснувши кнопку',
    },
    CHATBOT_CREATE: {
      UPLOADING: 'Завантаження',
      MODEL_AND_PROMPT: 'Вибір моделі ШІ та системного промпту',
      IMPORT_CHATBOT: 'Імпортувати чат-бота',
      CHATBOT_NAME: 'Ім’я чат-бота',
      CHATBOT_DESCRIPTION: 'Опис чат-бота',
      CHATBOT_AVATAR: 'Аватар чат-бота',
      UPLOAD_IMAGE_FOR_CHATBOT: 'Завантажити зображення для чат-бота',
      CREATE_CHATBOT: 'Створити чат-бота',
      START_CHAT: 'Почати розмову',
      SAVE_CHANGES: 'Зберегти зміни',
      AGREEMENT_TEXT: 'Я прочитав та погоджуюсь з',
      COMMUNITY_GUIDELINES: 'Правилами спільноти',
      MESSAGE_COST: 'Вартість повідомлення',
      GENDER: 'Стать',
      VISIBILITY: 'Видимість',
      ADD_TAGS: 'Додати теги',
      SEARCH_TAGS: 'Пошук тегів',
      NAME_PLACEHOLDER: 'Введіть назву чат-бота',
      DESCRIPTION_PLACEHOLDER:
        'Короткий опис чатбота, який відображатиметься в каталозі та попередньому перегляді.<br><br>Це не впливатиме на память чи промпти.',
      CREATE_NEW_CHATBOT: 'Створити нового чат-бота',
      EDIT_EXISTING_CHATBOT: 'Редагувати існуючого чат-бота',
      CHATBOT_PROFILE: 'Профіль чат-бота',
      GUIDE: 'Читати посібник',
      READ_CREATION_GUIDE: 'Прочитайте наш посібник зі створення чат-ботів',
      STATS_TITLE: 'Статистика',
      HAS_BEEN_STARTED: 'Було розпочато:',
      CHAT_TIME: 'Чат часу:',
      USER_MESSAGES: 'Повідомлень користувача:',
      CHARACTER_MESSAGES: 'Повідомлень персонажа:',
      USER_WORDS: 'Слів користувача:',
      CHARACTER_WORDS: 'Слів персонажа:',
      FILL_REQUIRED_FIELDS: "Необхідно заповнити обов'язкові поля!",
      MALE: 'Чоловічий',
      FEMALE: 'Жіночий',
      NON_BINARY: 'Небінарний',
      OTHER: 'Інший',
      NOT_SPECIFIED: 'Не вказано',
      PUBLIC: 'Публічний',
      PRIVATE: 'Приватний',
      VISIBLE_TOOLTIP: 'Публічний - видимий усім \n \n Приватний - видимий лише автору',
      AI_TOOLTIP:
        'ШI модель: Програма, навчена розуміти та генерувати текст як людина. \n \n Системний промпт: Прихована інструкція, яка вказує ШІ, як він повинен поводитися.',
      NO_ONLY_EMOJI: "Ім'я не може складатися лише з емодзі",
      COST_DEPENDS: 'Вартість залежить від різних параметрів: Модель, Промпт, Вітання, Сценарій.',
      PRICE_1_MESSAGE: 'Ціна за 1 повідомлення:',
      NOT_AVAILABLE: {
        TITLE: 'Це приватний чатбот',
        TEXT: 'Ви намагаєтеся отримати доступ до посилання на чатбота, доступ до якого обмежено його автором. Ви не можете переглядати або взаємодіяти з цим чатботом.',
        GO_HOME: 'На головну сторінку',
      },
      OTHER_CHATBOTS_BY_AUTHOR: 'Інші боти цього автора',
      SIMILAR_CHATBOTS: 'Схожі боти',
    },
  },
  MODALS: {
    MODEL_SETTINGS: {
      TITLE: 'Налаштування моделі',
      ADVANCED_SETTINGS: 'Розширені налаштування',
      APPLY_SETTINGS: 'Застосувати налаштування',
    },
    GENERATE_IMAGE: {
      GENERATE_BACKGROUND: 'Згенерувати фон',
      GENERATE_AVATAR: 'Згенерувати аватар',
      ENTER_PROMPT: 'Введіть підказку для генерації зображення',
      AGE_ERROR: 'Запит відхилено: вимоги безпеки. Персонажі молодше 18 років заборонені.',
    },
    CHATBOT_REMOVED: {
      TITLE: 'Чат-бот видалений',
      TEXT: 'Цей чат-бот був видалений автором або адміністратором. Почніть спілкуватися з іншими ботами вже зараз.',
      GO_HOME: 'На головну',
    },
    WELCOME: {
      TITLE: 'Ласкаво просимо',
      CAN_CHANGE: 'Ви можете змінити це в будь-який час',
      HOW_TO_ADDRESS: 'Як чат-бот буде до вас звертатися',
      AGE_AGREE: 'Я підтверджую, що мені 18 років або більше',
      BOUND_BY: 'Ви погоджуєтеся дотримуватися наших',
    },
    ALLOW_NSFW_CONTENT: {
      TITLE: 'Доступ до NSFW-контенту',
      TEXT: 'Відкрите відображення має бути ввімкнене у налаштуваннях вашого акаунта. Після ввімкнення ви зможете керувати відображенням NSFW-контенту прямо з головної сторінки.',
      GO_TO_PROFILE: 'Перейти до профілю',
    },
    CHAT_DECRYPT: {
      TITLE: 'Цей чат захищено паролем',
      TEXT: 'Введіть пароль для доступу до чату',
      ENCRYPT_PASSWORD: 'Пароль шифрування',
      CONFIRM_ENCRYPT_PASSWORD: 'Підтвердіть пароль шифрування',
    },
    CHAT_ENCRYPT: {
      TITLE: 'Сквозне шифрування',
      NOT_ENCRYPTED: 'Ваш чат не зашифрований',
      ENCRYPTED: 'Ваш чат зашифрований',
      TEXT: 'Повідомлення та чати захищені сквозним шифруванням. Треті сторони, включно з {{brand}}, не можуть читати ваші повідомлення.',
      ENTER_LABEL: 'Створіть пароль шифрування, якщо хочете увімкнути шифрування для чату з чат-ботом.',
      ENABLE: 'Увімкнути шифрування',
      DISABLE: 'Вимкнути шифрування',
    },
    CHARACTER_INFO: {
      CHOOSE_A_PERSONA: 'Виберіть персонажа:',
      AI_MODEL_AND_A_SYSTEM_PROMPT: 'AI-модель і системна підказка',
      TOOLTIP:
        'AI-модель: програма, навчена розуміти та генерувати текст як людина.\nСистемна підказка: прихована інструкція, яка вказує ШІ, як поводитися.',
      TAGS: 'Теги',
      START_CHAT: 'Почати чат',
    },
    IMAGES_GENERATION_SETTINGS: {
      IMAGES_TITLE: 'Зображення',
      NEGATIVE_PROMPT: 'Негативний промт',
      NEGATIVE_PROMPT_PLACEHOLDER: 'Напишіть, що ви не хочете бачити на зображеннях',
      STYLE_TITLE: 'Стиль',
      STYLE_ANIME: 'Аніме',
      UNI_STYLE: 'Універсальний стиль',
      STYLE_REALISTIC: 'Реалістичний',
      GENERATION_OF_NSFW: 'Генерація NSFW-зображень',
      GENERATION_OF_NSFW_TOOLTIP: 'Увімкніть, якщо хочете бачити контент, не призначений для неповнолітніх.',
      GUIDANCE_SCORE: 'Коефіцієнт спрямованості',
      CREATIVE: 'Креативний',
      PRECISE: 'Точний',
      DISABLE: 'Вимкнути',
      ENABLE: 'Увімкнути',
    },
    PROFILE_SETTINGS: {
      MY_ACCOUNT: {
        MY_ACCOUNT: 'Мій акаунт',
        CHANGE_PERSONA: 'Змінити персонажа',
        DEFAULT_PERSONA: 'Персонаж за замовчуванням',
        USERNAME: {
          USERNAME: 'Ім’я користувача',
          PLACEHOLDER: 'Введіть ім’я користувача',
          ERROR: 'Імʼя користувача може містити лише латинські літери (a–z), цифри та дефіси',
          ERROR_LENGTH: 'Ім’я користувача має бути від 3 до 20 символів.',
        },
        EMAIL: {
          EMAIL: 'Електронна пошта',
          PLACEHOLDER: 'Введіть вашу електронну пошту',
          VERIFIED: 'Пошту підтверджено',
          VERIFY: 'Підтвердити пошту',
          NOT_VERIFIED: 'Пошту не підтверджено',
        },
        EMAIL_VERIFICATION: {
          TITLE: 'Підтвердження пошти',
          TEXT_1: 'На адресу було надіслано лист',
          TEXT_2: 'Будь ласка, натисніть на посилання у цьому листі, щоб завершити підтвердження.',
          NO_CODE: 'Не отримали код?',
          RESEND: 'Надіслати ще раз',
          SEC: 'сек',
          ERROR: 'Не вдалося надіслати лист для підтвердження. {{error}}',
        },
        DATE_OF_BIRTH: 'Дата народження',
        DATE_OF_BIRTH_ERROR: 'Мінімальний вік має бути щонайменше 18 років',
        DESCRIPTION: 'Опис',
        DESCRIPTION_PLACEHOLDER: 'Введіть короткий опис тут',
        SOCIALS: 'Соцмережі',
        ADD_NEW: 'Додати нову',
        SAVE: 'Зберегти',
        SUCCESS: 'Дані успішно збережені!',
        FAIL: `Не вдалося зберегти дані, {{error}}`,
      },
      PASSWORD_RESET: {
        ENTER_NEW_PASSWORD: 'Введіть новий пароль у поля нижче.',
        INVALID_URL: 'Недійсне посилання. Будь ласка, запитайте скидання пароля знову.',
        APPLY_NEW_PASSWORD: 'Застосувати новий пароль',
        REQUEST_PASSWORD_RESET: 'Запитати скидання пароля',
      },
      PREFERENCES: {
        PREFERENCES: 'Налаштування',
        THEME: {
          THEME: 'Тема',
          SYSTEM: 'Системна',
          LIGHT: 'Світла',
          DARK: 'Темна',
        },
        NSFW: {
          TITLE: 'Відображати чат-боти з відвертими зображеннями або мовою (NSFW)',
          ERROR: 'Ви не можете ввімкнути відображення контенту NSFW. Будь ласка, підтвердіть, що вам виповнилося 18 років на ',
          LINK: 'вкладці «Мій обліковий запис»',
        },
        NOTIFICATIONS: {
          SUCCESS: 'Налаштування успішно застосовано!',
          FAIL: 'Не вдалося застосувати налаштування',
        },
      },
      SECURITY: {
        SECURITY: 'Безпека',
        TWO_FACTOR: {
          TITLE: 'Двофакторна автентифікація',
          DESCRIPTION: 'Двофакторна автентифікація (2FA) забезпечує надійніший захист облікового запису.',
          DOWNLOAD: 'Завантажити Google Authenticator',
          APP_DESCRIPTION:
            'Google Authenticator – це незалежна служба від Google Inc., яка допомагає захистити ваш обліковий запис. Після налаштування вам потрібно буде підтвердити вхід у програму або виведення коштів за допомогою пароля, згенерованого Google Authenticator.',
          SCAN: 'Відскануйте QR-код або завантажте з магазину додатків',
          DOWNLOAD_ON_THE: 'Завантажити на',
          WORKS_WITH: 'Працює з',
          STEP: {
            STEP: 'Крок',
            ONE: 'Завантажте додаток',
            TWO: 'Додати ключ',
            THREE: 'Введіть код',
          },
          CONTINUE: 'Продовжити',
          CONFIRM: 'Підтвердити',
          ADD_KEY: 'Додайте ключ до Google Authenticator та створіть резервну копію',
          ADD_KEY_TIP: 'Відкрийте Google Authenticator, проскануйте QR-код або введіть ключ нижче, щоб додати токен підтвердження.',
          SCAN_QR_CODE: 'Відскануйте QR-код або введіть ключ нижче в додаток',
          CODE_TIP: 'Збережіть свій ключ на випадок виникнення проблем зі входом, таких як втрата телефону чи інші проблеми.',
          COPY: 'Копіювати',
          COPIED: 'Скопійовано',
          ENTER: 'Введіть код із програми Google Authenticator.',
          ENTER_TIP: 'Відкрийте застосунок GA та введіть код підтвердження в поле нижче.',
          GA_CODE: 'Код GA',
          ENTER_CODE: 'Введіть код',
        },
        PASSWORD: {
          AGO: 'Змінено',
          CURRENT: 'Поточний пароль',
          NEW: 'Новий пароль',
          CONFIRM: 'Підтвердьте новий пароль',
          SIGN_OUT: 'Вийти з усіх активних облікових записів',
          CHANGE: 'Змінити пароль',
          SUCCESS: 'Пароль успішно змінено!',
          FAIL: 'Не вдалося змінити пароль, {{error}}',
        },
        SOCIAL: {
          TITLE: 'Вхід через соціальні мережі',
          DESCRIPTION:
            'Підключіть свій обліковий запис CAICHAT.AI до облікових записів соціальних мереж для простого та безпечного входу. Вхід через соціальні мережі пропускає двоетапну перевірку та може знизити безпеку вашого облікового запису.',
          CONNECT: 'Підключити',
          DISCONNECT: 'Відключити',
          CONNECTED: 'Підключено',
          NOT_CONNECTED: 'Не підключено',
          NOTIFICATIONS: {
            SUCCESS: 'Обліковий запис {{providerName}} успішно відключено',
            FAIL: 'Не вдалося відключити обліковий запис, {{error}}',
          },
        },
      },
    },
    PAYMENTS: {
      RENEWAL: 'Продовження відбудеться через {{period}} днів за {{price}}/{{period}} днів. Скасувати можна будь-коли.',
      SECURE: 'Платежі захищені та зашифровані',
      TOS_1: 'Натискаючи кнопку "Надіслати", ви підтверджуєте, що вам 18 років або більше, і ви приймаєте',
      TOS_2: 'та',
      TOS_3: '. Ми дбаємо про вашу конфіденційність, тому платіж у виписці по карті буде відображатися як "{{ brand }}".',
      TOS_4: 'З будь-яких питань щодо платежів, будь ласка, зверніться до служби підтримки за адресою {{ email }}.',
      TOS_5: 'Ви погоджуєтеся, що ми збережемо вашу платіжну інформацію, щоб вам не потрібно було вводити її знову в майбутньому.',
    },
    DELETE_CHAT: {
      TITLE: 'Видалити чат',
      TEXT: 'Ви впевнені, що хочете видалити цей чат? Після видалення його неможливо буде відновити.',
      SUCCESS: 'Чат успішно видалено!',
      FAIL: 'Не вдалося видалити чат!',
    },
    DELETE_PERSONA: {
      TITLE: 'Видалити персонажа',
      TEXT:
        'Видалення цього персонажа призведе до незворотних наслідків — відновити його буде неможливо.\n' +
        'Історія спілкування з ботами залишиться, і ви зможете продовжити розмову, але від імені іншого персонажа.\n' +
        '\n',
      SURE: 'Ви впевнені, що хочете видалити цей профіль?',
      WARNING: 'Поточний персонаж за замовчуванням не можна видалити.\n' + 'Спочатку виберіть іншого за замовчуванням або створіть нового.',
      SUCCESS: 'Персонажа успішно видалено!',
      FAIL: 'Не вдалося видалити персонажа!',
    },
    DELETE_CHATBOT: {
      TITLE: 'Видалити чат-бота',
      TEXT_1: 'Видалення чат-бота також призведе до видалення всіх чатів та зображень у них. Їх неможливо буде відновити.',
      TEXT_2: 'Ви впевнені, що хочете видалити цього чат-бота?',
      SUCCESS: 'Чат-бот успішно видалений!',
      FAIL: 'Не вдалося видалити чат-бота!',
    },
    BLOCK_CREATOR: {
      TITLE: 'Заблокувати цього автора?',
      TEXT: 'Ви впевнені, що хочете заблокувати всіх чат-ботів цього автора? Ви можете розблокувати їх у будь-який час.',
      BLOCK: 'Заблокувати',
    },
    UNBLOCK_CREATOR: {
      TEXT: 'Ви впевнені, що хочете розблокувати автора ',
      CANCEL: 'Ні',
      SUCCESS: 'Автора успішно розблоковано!',
      FAIL: 'Не вдалося розблокувати автора. Будь ласка, спробуйте пізніше.',
    },
    COMPLAIN: {
      TITLE: 'Скарга',
      MAX_CHECKBOXES: 'Ви можете вибрати максимум 5 чекбоксів',
      CHECKBOX: {
        THREATS: 'Погрози та домагання',
        CRUELTY: 'Надмірна жорстокість',
        FALSE: 'Хибні твердження',
        HATRED: 'Розпалювання ненависті',
        NSFW: 'Непридатне для роботи (NSFW)',
        HARASSMENT: 'Сексуальні домагання',
        CHILD_EXPLOIT: 'Експлуатація дітей',
        SELF_HARM: 'Самопошкодження',
        TERRORISM: 'Тероризм і екстремізм',
        ILLEGAL: 'Незаконна діяльність',
        DRUGS: 'Наркоторгівля',
        CONFIDENTIALITY: 'Порушення конфіденційності',
        IMPERSONATION: 'Самозванство',
        SPAM: 'Комерційний спам',
      },
    },
    TELL_US_MORE: {
      TITLE: 'Розкажіть більше',
      ADDITIONAL_DETAILS: 'Додаткові деталі',
      DETAILS_PLACEHOLDER: 'Опишіть проблему детальніше',
      SUCCESS: 'Ваш відгук успішно надіслано!',
      FAIL: 'Не вдалося надіслати відгук. Будь ласка, спробуйте пізніше.',
      FUNNY: 'Смішно',
      HEALTHY: 'Корисно',
      FLIRTY: 'Фліртливо',
      INTERESTING: 'Цікаво',
      GOOD_MEMORY: 'Хороша пам’ять',
    },
    MODEL_CARD_CREATOR: {
      SET_FAVORITE: {
        SUCCESS: 'Модель успішно додана в обране',
        FAIL: 'Не вдалося додати в обране, спробуйте пізніше.',
      },
      UNSET_FAVORITE: {
        SUCCESS: 'Модель успішно видалена з обраного',
        FAIL: 'Не вдалося видалити з обраного, спробуйте пізніше.',
      },
    },
    PROMPTS_CARD_CREATOR: {
      SET_FAVORITE: {
        SUCCESS: 'Промпт успішно додано в обране',
        FAIL: 'Не вдалося додати в обране, спробуйте пізніше.',
      },
      UNSET_FAVORITE: {
        SUCCESS: 'Промпт успішно видалено з обраного',
        FAIL: 'Не вдалося видалити з обраного, спробуйте пізніше.',
      },
    },
    MEMORIES: {
      TITLE: 'Спогади',
      PLACEHOLDER_1: 'Тут ще немає спогадів.',
      PLACEHOLDER_2: 'Продовжуйте чат з ботом або створіть нового.',
      INPUT_PLACEHOLDER: 'Додати новий спогад...',
      SUBTITLE: 'Додайте спогади про ваші попередні взаємодії з персонажем',
      EDIT: 'Редагувати спогад',
      DELETE: 'Видалити спогад',
      PIN: 'Закріпити спогад',
      UNPIN: 'Відкріпити спогад',
      PINNED: '(Закріплено)',
      EDITED: '(змінено)',
      DELETE_TEXT: 'Ви впевнені, що хочете видалити цей спогад? Після видалення його неможливо буде відновити.',
      MEMORIES_ENABLED: 'Спогади успішно увімкнено!',
      MEMORIES_DISABLED: 'Спогади успішно вимкнено!',
      FAILED_TO_UPDATE: 'Не вдалося оновити налаштування спогадів!',
    },
    REGISTRATION: {
      LOGIN_WITH_EMAIL: 'Увійти за допомогою email',
      CONTINUE: 'Продовжити',
      HAVE_AN_ACCOUNT: 'Вже маєте акаунт?',
      DONT_HAVE_AN_ACCOUNT: 'Немає акаунта?',
      YOU_AGREE: 'Реєструючись, ви погоджуєтесь з нашими',
      TERMS_AND_CONDITIONS: 'Умовами та положеннями',
      YOU_HAVE_READ: 'і ви ознайомилися з нашою',
      PRIVACY_POLICY: 'Політикою конфіденційності',
      FORGOT_PASSWORD: 'Забули пароль?',
    },
    PASSWORD_RECOVERY: {
      TITLE: 'Відновити пароль',
      RECOVERY_LINK:
        'Посилання для відновлення пароля було надіслано на вашу пошту. Будь ласка, перевірте скриньку та перейдіть за посиланням, щоб скинути пароль.',
      ENTER_EMAIL: 'Введіть адресу електронної пошти, яку ви використовували при реєстрації, і ми надішлемо вам інструкції',
      RESET_PASSWORD: 'Скинути пароль',
    },
    RESET_PASSWORD: {
      ENTER_PASSWORD: 'Введіть новий пароль у поля нижче',
      APPLY: 'Застосувати новий пароль',
      ERROR: 'Недійсна URL-адреса. Будь ласка, надішліть запит на скидання пароля.',
    },
    NONEXISTING: {
      TITLE: 'Ой...',
      TEXT: 'Те, що ви шукаєте, може бути в іншому місці або просто не існує. Будь ласка, спробуйте ще раз.',
    },
    CHOOSE_PERSONA: {
      TITLE: 'Вибрати персонажа',
      SUBTITLE: 'Зміна персонажа під час розмови може порушити сюжетну послідовність.',
      SUCCESS: 'Персонажа успішно змінено!',
      FAIL: 'Не вдалося змінити персонажа!',
    },
    IMPORT_CHATBOT: {
      TITLE: 'Імпорт чат-бота',
      DESCRIPTION: 'Наразі ми підтримуємо імпорт персонажів із spicychat.ai та juicychat.ai.',
      IMPORT_FROM_FILE: {
        TITLE: 'Імпорт за допомогою JSON або зображення картки',
        DESCRIPTION: 'Завантажте JSON-файл символів або зображення із вбудованими даними символів.',
        SUPPORTED_LABEL: 'Підтримувані формати:',
        SUPPORTED_FORMATS: 'JSON, PNG, JPG',
        CLICK: 'Натисніть, щоб вибрати або перетягніть файл сюди',
      },
      IMPORT_FROM_URL: {
        TITLE: 'Імпорт за URL-адресою',
        ENTER: 'Введіть URL-адресу з підтримуваних веб-сайтів',
        CHATBOT_URL: 'URL-адреса чат-бота',
        IMPORT_FROM_URL: 'Імпорт з URL-адреси',
      },
    },
    BOOSTY_PAYMENT_STATUS: {
      LINK_ACCOUNT: "Прив'яжіть свій акаунт Boosty",
      ENTER_EMAIL_DESCRIPTION: "Для оплати підписки Boosty, будь ласка, введіть Email, прив'язаний до вашого акаунту Boosty нижче",
      EMAIL_WARNING: "Увага! Email прив'язується до вашого акаунту CAICHAT і не може бути змінений",
      EMAIL_LABEL: "Email, прив'язаний до Boosty",
      EMAIL_PLACEHOLDER: 'Введіть ваш Email',
      WHERE_FIND_EMAIL: 'Де знайти інформацію про мій email на Boosty?',
      INSTRUCTION_STEP_1: 'Натисніть на свій аватар і виберіть "Налаштування акаунту" з випадаючого меню',
      INSTRUCTION_STEP_2: 'На вкладці "Профіль" ви знайдете свій Email. Просто скопіюйте його і вставте в форму на цій сторінці',
      HAVE_YOU_PAID: 'Ви оплатили підписку?',
      CONFIRM_PAYMENT_DESCRIPTION:
        'Якщо ви оплатили підписку Boosty, будь ласка, підтвердіть це нижче. Ми синхронізуємо дані для перевірки.',
      SYNC_FAILED: 'Синхронізація не вдалася. Будь ласка, перевірте правильність вашого email та успішність оплати підписки Boosty.',
      CONTACT_SUPPORT: "Якщо у вас є питання або потрібно змінити вказаний Email, будь ласка, зв'яжіться з підтримкою.",
      RETURN_TO_BOOSTY: 'Повернутися до оплати на Boosty',
      I_HAVE_PAID: 'Я оплатив',
      SUCCESS_PAYMENT: 'Ви успішно оплатили підписку Boosty!',
      CONGRATULATIONS: 'Вітаємо! Тепер ви можете використовувати більше функцій на CAICHAT.AI. Починайте нові чати прямо зараз!',
      DATA_SYNCHRONIZED: 'Дані синхронізовані',
      SUBSCRIPTION_VALID_UNTIL: 'Підписка дійсна до',
      MY_PREVIOUS_CHATS: 'Мої попередні чати',
      GO_TO_HOMEPAGE: 'Перейти на головну',
      SYNCHRONIZING_DATA: 'Синхронізація даних',
    },
    TOP_UP: {
      TITLE: 'Поповніть баланс токенів',
      NOT_ENOUGH: 'У вас недостатньо',
      TOKENS: 'токенів для створення зображень.',
      TOP_UP_AND: 'Поповніть баланс і',
      GENERATE_AMAZING_PHOTOS: 'створюйте вражаючі фото',
      RIGHT_IN_THE_CONVERSATION: 'просто в розмові!',
      BUY_TOKENS: 'Купити токени',
    },
  },
  BLOCKS: {
    SORT: {
      MOST_CHATS: 'Найбільше чатів',
      NEWEST: 'Найновіші',
      OLDEST: 'Найстаріші',
      MOST_POPULAR: 'Найпопулярніші',
      MOST_LIKED: 'Найбільше вподобані',
    },
    LEFT_SIDEBAR: {
      HOME: 'Головна',
      CHATS: 'Чати',
      MY_PERSONAS: 'Мої персонажі',
      CREATE_CHATBOT: 'Створити чат-бота',
      MY_CHATBOTS: 'Мої чат-боти',
      FAVORITES: 'Вибране',
      BLOCKED_CREATORS: 'Заблоковані автори',
      SUBSCRIBE: 'Підписка',
      NOTIFICATIONS: 'Сповіщення',
      HELP: 'Допомога',
    },

    RIGHT_SIDEBAR: {
      UPGRADE_PLAN: 'Оновити план',
      GET_PLAN: 'Оновити підписку',
      ACTIVE: 'Активний',
      DREAMER: 'Мрійник',
      EXPLORER: 'Дослідник',
      STORY_GOD: 'Бог історій',
      NEW_CHAT: 'Новий чат',
      EXTENSIONS: 'Розширення',
      CREATE_PRESET: 'Створити пресет',
      PERSONAS: 'Персонажі',
      RECENT: 'Нещодавно використані моделі штучного інтелекту',
      PROMPT: 'Промпт',
      NO_MODEL_SELECTED: 'Модель не вибрано для продовження чату',
      SELECT_MODEL_PROMPT: 'Виберіть модель і промпт',
      SELECT_MODEL: 'Вибрати ІІ-модель',
    },

    CATALOG_FILTER_PANEL: {
      RESET_FILTER: 'Скинути фільтр',
      SEARCH_TAGS: 'Пошук тегів',
      SHOW: 'Показати',
      CHATBOTS: 'чат-ботів',
    },

    SAFE_SEARCH_TOGGLE: {
      SAFE_SEARCH: 'Безпечний пошук',
    },

    CHATBOT_INFO: {
      TYPE_GREETING_NAME: 'Введіть привітання',
      ADD_NEW_GREETING: 'Додати нове привітання',
      GREETINGS: 'Привітання',
      PERSONALITY: 'Особистість',
      SCENARIO: 'Сценарій',
      DIALOG: 'Діалог',
      NOTES: 'Нотатка автора',
      DESCRIPTION: 'Опис',
      AVATAR: 'Аватар',
      NAME: 'Ім’я',
      GREETINGS_PLACEHOLDER:
        'Наприклад: Відома археолог з таємничим минулим, Елара Найтшейд провела десятиліття, досліджуючи забуті храми та давні руїни по всьому світу. З її характерними сріблястими пасмами та проникливими янтарними очима вона здобула повагу в академічних колах, зберігаючи ауру загадковості.',
      PERSONALITY_PLACEHOLDER:
        'Опишіть особистість персонажа, риси характеру, минуле, стиль мови тощо. Використовуйте чітку та лаконічну мову. Приклади: «гострий та саркастичний», «завжди говорить римами», «боїться павуків», «колишній детектив, якого переслідує минула справа».',
      SCENARIO_PLACEHOLDER: 'Опишіть сценарій для персонажа. Використовуйте чітку та лаконічну мову.',
      DIALOG_PLACEHOLDER:
        "Наведіть приклад діалогу, який показує, як говорить персонаж. Використовуйте формат: 'Користувач: Привіт\nПерсонаж: [відповідь персонажа]'. Додайте кілька реплік, щоб продемонструвати стиль спілкування.",
      NOTES_PLACEHOLDER: 'Напишіть коротке пояснення для користувачів, як найкраще взаємодіяти з цим ботом',
      CHAT_BACKGROUND: 'Фон чату',
      DELETE_CHAT_BACKGROUND: 'Видалити фон чату',
      HIDE_THIS_BLOCK: 'Приховати цей блок',
    },

    TOKENIZATOR: {
      TOKENS: 'токени',
    },

    BLOCK_BUTTON: {
      NO_BLOCKED: 'У вас немає заблокованих авторів',
      SHARE: 'Поділитися',
      DELETE_CHATBOT: 'Видалити чат-бота',
      EDIT: 'Редагувати',
      BLOCK_CREATOR: 'Заблокувати автора',
      UNBLOCK_CREATOR: 'Розблокувати автора',
      REPORT: 'Поскаржитися на автора',
      REPORT_CHATBOT: 'Поскаржитися на чат-бот',
      VOICE_OVER: 'Озвучення',
      DELETE_IMAGE: 'Видалити зображення',
      REGENERATE_MESSAGE: 'Згенерувати повідомлення знову',
      NEW_CHAT_FROM_HERE: 'Новий чат звідси',
      BLOCK_SUCCESS: 'Користувач успішно заблокований',
      BLOCK_ERROR: 'Не вдалося заблокувати користувача. Спробуйте пізніше.',
      UNBLOCK_SUCCESS: 'Користувач успішно розблокований',
      UNBLOCK_ERROR: 'Не вдалося розблокувати користувача. Спробуйте пізніше.',
      IMAGE_SETTINGS: 'Налаштування зображення',
      RATE_MESSAGE: 'Оцінити повідомлення',
    },

    CHAT_INPUT: {
      ACTION: 'Дія',
      TYPE_YOUR_MESSAGE: 'Введіть повідомлення...',
      EDIT_MESSAGE_PLACEHOLDER: 'Редагувати повідомлення...',
      DELETED_PERSONA_PLACEHOLDER: 'Вашу персону видалено. Виберіть іншу.',
      DELETED_PRESET_PLACEHOLDER: 'Модель недоступна. Будь ласка, виберіть іншу.',
      SUBSCRIBE_PLACEHOLDER: 'Обрана AI-модель недоступна для поточної підписки.',
      SELECT_PERSONA: 'Вибрати персонажа',
    },

    PRICING_CARD_GROUP: {
      WEEKLY: 'На тиждень',
      MONTHLY: 'На місяць',
      YEARLY: 'На рік',
      SUBSCRIBE_PLAN: 'Оформити підписку',
      UP_TO: 'До {{percent}}%',
      OFF: 'Знижка {{percent}}%',
    },

    PRICING_CARD: {
      MOST_POPULAR: 'Найпопулярніший',
      MY_SUBSCRIPTION: 'Моя підписка',
      SUBSCRIBE: 'Підписатися',
      UNSUBSCRIBE: 'Відписатися',
      IN_ADDITION: 'На додаток до попередніх рівнів:',
      WEEKLY: 'тиждень',
      MONTHLY: 'місяць',
      YEARLY: 'рік',
    },

    MY_PROFILE_CARD: {
      DATE_OF_BIRTH: 'Дата народження:',
      REGISTERED: 'Зареєстровано:',
      SUBSCRIBERS: 'Підписники',
      LIKES: 'Лайки',
      MY_CHATBOTS: 'Мої чат-боти',
      MY_PUBLIC_PAGE: 'Моя публічна сторінка',
      BALANCE: 'Баланс:',
      ADD_TOKENS: 'Додати токени',
    },
    CHAT_HEADER: {
      DISCLAIMER:
        'CAICHAT.AI працює на базі ШІ для творчого сторітелінгу та рольових ігор. Усі розмови вигадані, не сприймайте їх як реальні факти. Використовуйте відповідально!',
      SHOW_PREVIOUS: 'Показати попереднє',
    },
    OVERLAY_INVITE_CODE: {
      TITLE: 'Ваша історія починається тут!',
      SUBTITLE: 'Залишився лише один крок, щоб розблокувати чудові функції',
      ENTER_CODE: 'Введіть код запрошення',
      INVITE_CODE: 'Код запрошення',
      LETS_GO: 'Поїхали!',
      NEED_CODE: 'Потрібен код запрошення?',
      JOIN_DISCORD: 'Приєднайтесь до Discord для доступу',
      SIGN_OUT: 'Вийти',
    },

    TOKEN_PACK_CARD: {
      BUY: 'Купити',
      SALE: 'Знижка',
    },

    COMPARE_PLANS_TABLE: {
      MOST_POPULAR: 'Популярно',
      FUNCTION_LIMIT: 'Функція/Ліміт',
      INCLUDED_IN_PLAN: 'Включено в план',
      NOT_INCLUDED_IN_PLAN: 'Не включено в план',
      MAIN_FUNCTION: 'ОСНОВНА ФУНКЦІЯ',
      BONUS_FOR_SUB: 'Бонусні токени за підписку (при поновленні)',
      UNLIMITED_MESSAGES: 'Безлімітні повідомлення',
      COUPON_MONTH: 'Разовий купон при підписці на 30 днів',
      COUPON_YEAR: 'Разовий купон при річній підписці',
      USER_IDENTITIES: 'Персонажі користувача',
      USER_IDENTITIES_TOOLTIP:
        'Після завершення підписки ви перейдете на Free plan і не зможете створювати нових персон, доки не звільните місце.',
      ABILITY_TO_USE: 'Можливість використовувати власні моделі',
      ACCESS_OTHER_EXTENSIONS: 'Доступ до інших та стандартних розширень',
      AVAILABLE_CONTEXT_TOKENS: 'Доступні токени контексту',
      AVAILABLE_LLM_TOKENS: 'Доступні токени відповіді LLM',
      LIMITATION_ON_MODELS: 'ОБМЕЖЕННЯ ПО МОДЕЛЯХ',
      AVAILABLE_CHARACTERS: 'Доступні персонажі',
      NO_RESTRICTIONS:
        'Немає обмежень на використання Контексту, Відповідей LLM, Персонажів і системних підказок при використанні власних моделей, крім зазначених у розділі «Ваші AI моделі»',
      CREATE_EXTENSIONS: 'Створювати власні розширення',
      ADDITIONAL_FEATURES: 'ДОДАТКОВІ ФУНКЦІЇ',
      SYSTEM_PROMPTS: 'Системні підказки',
      IMAGE_GEN: 'Генерація зображень доступна за токени – певна кількість зображень на день безкоштовно (обмеження на місяць/тиждень)',
      AVATAR_GEN_ALL: 'Генерація аватарів для всіх персонажів, включаючи приватних',
      CHAT_ENCRYPTION: 'Шифрування чату',
      ACCESS_EXTENSIONS: 'Доступ до розширень',
      ACCESS_MEMORY_MANAGER: 'Доступ до менеджера пам’яті (Memories) з можливістю додавати власні записи',
      SEMANTIC_MEMORY: 'Семантична пам’ять 2.0',
      TTS: 'Текст-в-Мову (озвучка відповідей)',
      CREATE_PRIVATE_CHARACTERS: 'Створювати приватних персонажів',
      CREATE_PUBLIC_CHARACTERS: 'Створювати публічних персонажів',
      AD_FREE: 'Без реклами',
      NO_QUEUE: 'Без черги',
      ADDITIONAL_TOOLS: 'Додаткові інструменти для створення персонажів та розширень',
      LIMITED_EDITION_MODEL: 'Модель обмеженого випуску',
      UP_TO_200: 'до 200',
      UNLIMITED: 'Безліміт',
      UP_TO_1_PER_DAY: 'До 1 безкоштовно на день',
      ONLY_YOUR_OWN_AND_FREE: 'Тільки свої та безкоштовні',
      RECOMMENDED_MODELS_WITHOUT_LIMITATIONS: 'Наші рекомендації без обмежень по токенах',
      UP_TO_5_PER_DAY_PLUS_UNLIMITED_FOR_FEE: 'До 5 на день + безліміт за плату',
      ONLY_SPEECH: 'Тільки мова',
      UNLIMITED_LOW_QUALITY: 'Безліміт, низька якість',
      UNLIMITED_MEDIUM_QUALITY: 'Безліміт, середня якість',
      UNLIMITED_HIGH_QUALITY: 'Безліміт, висока якість',
      TEN_PERCENT_DISCOUNT_ONE_WEEK: '10% знижка на тиждень',
      MONTHLY_COUPON_TEN_PERCENT_DISCOUNT: 'Щомісячний купон: 10% знижка на токени на тиждень',
      TWENTY_PERCENT_DISCOUNT_ONE_WEEK: '20% знижка на тиждень',
      MONTHLY_COUPON_TWENTY_PERCENT_DISCOUNT: 'Щомісячний купон: 20% знижка на токени на тиждень',
      THE_ENTIRE_ANSWER: 'Повна відповідь',
      THIRTY_PERCENT_DISCOUNT_ONE_WEEK: '30% знижка на тиждень',
      MONTHLY_COUPON_THIRTY_PERCENT_DISCOUNT: 'Щомісячний купон: 30% знижка на токени на тиждень',
      AVAILABLE_CHARACTERS_TOOLTIP:
        'Персонажі, на яких витрачено більше 2000 токенів на особистість і більше 3000 токенів на привітання (береться більше значення), не можуть використовувати безкоштовні моделі.',
      UP_TO_5k_TOKENS: 'До 5000 токенів, витрачених на особистість',
      UP_TO_5k_TOKENS_ACTIVE: 'До 5000 токенів на особистість + моделі рівня Active',
      UP_TO_5k_TOKENS_DREAMER: 'До 5000 токенів на особистість + моделі рівня Dreamer',
      UP_TO_5k_TOKENS_CREATOR: 'До 5000 токенів на особистість + моделі рівня Creator',
      UP_TO_5k_TOKENS_STORY_GOD: 'До 5000 токенів на особистість + моделі рівня Story GOD',
      ACTIVE: 'Активний',
      FREE_PLAN: 'Безкоштовний',
      FREE_MODELS: 'Безкоштовні моделі',
      FREE_MODELS_FREE: 'Безкоштовні моделі для персонажів з особистістю до 5000 токенів',
      FREE_MODELS_ACTIVE: 'Моделі безкоштовного плану + моделі рівня Активний',
      FREE_MODELS_DREAMER: 'Моделі безкоштовного плану + моделі рівня Мрійник',
      FREE_MODELS_CREATOR: 'Моделі безкоштовного плану + моделі рівня Творець',
      FREE_MODELS_STORY_GOD: 'Моделі безкоштовного плану + моделі рівня Бог історій',
    },

    MODEL_PROMPT_PRESET: {
      MODEL: 'Модель',
      DEFAULT: 'За замовчуванням',
      RECOMMENDED: 'Рекомендовано',
      PRESET: 'Пресет',
      LAST_USED: 'Нещодавно',
      SUCCESS: 'Налаштування успішно застосовані!',
      ERROR: 'Не вдалося застосувати налаштування!',
      INCOMPATIBLE: 'Несумісно з моделлю ШІ',
      WE_RECOMMEND: 'Ми рекомендуємо',
      AUTHORS_CHOICE: 'Вибір автора',
      POPULAR: 'Популярне',
      UNSUITABLE_SUBSCRIPTION: 'Ваш тарифний план не підходить для цієї моделі.',
    },

    PUBLIC_PROFILE_HEADER: {
      COPIED: 'скопійовано',
      SUBSCRIBERS: 'Підписники',
      LIKES: 'Лайки',
      CHATBOTS: 'Чат-боти',
      YOU_HAVE_BLOCKED_THIS_AUTHOR: 'Ви заблокували цього автора. ',
      UNBLOCK: 'Розблокувати',
    },

    PROMPTS_BLOCK: {
      REPLACE: 'Замінити AI модель',
      SELECT: 'Вибрати AI модель',
    },
    FILE_UPLOAD: {
      UPLOAD: 'Завантажити',
    },
    SUBSCRIBE_BOOSTY: {
      CAN_SUBSCRIBE: 'Ви також можете оформити підписку через Boosty, який пропонує гнучкі варіанти для ваших потреб.',
      HAVE_SUBSCRIBE: 'У вас вже є підписка через Boosty. Ваша підписка дійсна до:',
      GO_TO_BOOSTY: 'Перейти до Boosty',
      SUBSCRIBE_TO_BOOSTY: 'Підписатися на Boosty',
    },
    TAGS_SELECT: {
      TAGS: 'Теги',
      PLACEHOLDER: 'Позначте свого персонажа відповідними ключовими словами (максимум 10 тегів)',
      CREATE_NEW: 'Створити новий – ',
      LIMIT: 'Максимум 10 тегів',
      CUSTOM_TAG_VALIDATION: 'Користувацькі теги повинні містити від 3 до 20 символів (лише буквено-цифрові).',
    },
  },
  UTILS: {
    SMART_DATE_FORMAT: {
      JUST_NOW: 'Щойно',
      MINUTES_AGO: '{{count}} {{minutes}} тому',
      HOURS_AGO: '{{count}} {{hours}} тому',
      DAYS_AGO: '{{count}} {{days}} тому',
      WEEKS_AGO: '{{count}} {{weeks}} тому',
      MONTHS_AGO: '{{count}} {{months}} тому',
      ONE_MINUTES: 'хвилину',
      FEW_MINUTES: 'хвилини',
      MANY_MINUTES: 'хвилин',
      ONE_HOURS: 'годину',
      FEW_HOURS: 'години',
      MANY_HOURS: 'годин',
      ONE_DAYS: 'день',
      FEW_DAYS: 'дні',
      MANY_DAYS: 'днів',
      ONE_WEEK: 'тиждень',
      FEW_WEEKS: 'тижні',
      MANY_WEEKS: 'тижнів',
      ONE_MONTH: 'місяць',
      FEW_MONTHS: 'місяці',
      MANY_MONTHS: 'місяців',
    },
    SMART_MESSAGE_FORMAT: {
      ONE_MESSAGES: 'повідомлення',
      FEW_MESSAGES: 'повідомлення',
      MANY_MESSAGES: 'повідомлень',
    },
    TIME: {
      H: 'г',
      M: 'хв',
      S: 'с',
    },
  },
  NOTIFICATIONS: {
    CHATBOT_CREATE: {
      SUCCESS: 'Чат-бот "{{name}}" успішно створено!',
      UPDATE_SUCCESS: 'Чат-бот успішно оновлено!',
      UPDATE_ERROR: 'Помилка оновлення чат-бота!',
      REQUIRED_FIELDS: "Обов'язкові поля мають бути заповнені:",
    },
    CHAT_MESSAGE: {
      NEW_CHAT_STARTED: 'Нова розмова розпочата з обраного повідомлення!',
      ERROR: 'Під час обробки запиту сталася помилка',
      REPORT_MESSAGE_SENT: 'Ваша скарга надіслана',
      ENCRYPTION_SAVE: 'Ваші налаштування шифрування успішно збережено.',
      ENCRYPTION_DELETE: 'Шифрування скасовано.',
      ENCRYPTION_LIMIT:
        'Ви досягли ліміту зашифрованих чатів! Розшифруйте кілька чатів або оновіть свій тариф, щоб продовжити шифрувати нові.',
    },
    TEXT_TO_SPEECH_ERROR:
      'Ми не змогли отримати доступ до вашого мікрофона. Будь ласка, перевірте дозволи браузера або пристрою, щоб увімкнути перетворення мовлення в текст.',
    PASSWORD_CHANGED: 'Пароль успішно змінено',
    FAILED_TO_LOAD_IMAGE: 'Не вдалося завантажити зображення!',
    COPIED_TO_CLIPBOARD: 'Скопійовано в буфер обміну',
  },
  COMMON: {
    ADD: 'Додати',
    OR: 'або',
    AND: 'і',
    BY: 'від',
    FREE: 'БЕЗКОШТОВНО',
    EXAMPLE: 'Приклад',
    CONTINUE: 'Продовжити',
    CONFIRM: 'Підтвердити',
    DELETE: 'Видалити',
    DELETED: 'Видалено',
    SAVE: 'Зберегти',
    SUBMIT: 'Надіслати',
    REGENERATE: 'Згенерувати знову',
    GENERATE: 'Згенерувати',
    GENERATING: 'Генерується',
    GENERATION: 'Генерація...',
    CREATE: 'Створити',
    CANCEL: 'Скасувати',
    COPY: 'Копіювати',
    COPIED: 'Скопійовано',
    BACK: 'Назад',
    LOG_IN: 'Увійти',
    SIGN_IN: 'Авторизація',
    SIGN_UP: 'Реєстрація',
    SIGN_IN_WITH: 'Увійти за допомогою {{ provider }}',
    PASSWORD: 'Пароль',
    CONFIRM_PASSWORD: 'Підтвердіть пароль',
    NOT_AVAILABLE: 'Недоступно',
    CLOSE: 'Закрити',
    MIN: 'Мін',
    MAX: 'Макс',
    PLACEHOLDER: {
      SEARCH: 'Пошук...',
    },
    FILE_INPUT: {
      INVALID_FILE_TYPE: 'Файл {{fileName}} має недопустимий тип. Дозволені типи: {{allowedTypes}}',
      MAX_FILE_SIZE: 'Файл {{fileName}} перевищує максимальний розмір {{maxSize}}МБ',
      DRAG_AND_DROP_TO_UPLOAD_IMAGE: 'Перетягніть або натисніть, щоб завантажити зображення',
      DROP_FILE: 'Перетягніть файл сюди',
      CHOOSE_FILE: 'Вибрати файл',
    },
    ERROR: {
      INVALID_FIELD: 'Поле неприпустиме',
      FILLED_IN: 'Поле має бути заповнене',
      MIN_LENGTH: 'Мінімальна довжина — {{length}} символів',
      MAX_LENGTH: 'Максимальна довжина — {{length}} символів',
      NO_SPACES: 'Поле не може починатися, закінчуватися або складатися лише з пробілів',
      INVALID_EMAIL: 'Невірна адреса електронної пошти',
      INVALID_CURRENT_PASSWORD: 'Поточний пароль недійсний',
      PASS_NOT_CHANGED: 'Новий пароль має відрізнятися від старого',
      INVALID_USERNAME: 'Невірне ім’я користувача',
      INVALID_USERNAME_EXPANDED:
        'Імʼя користувача має бути від 3 до 20 символів і може містити лише латинські літери (a–z), цифри та дефіси',
      DUMB_ERROR: 'Щось пішло не так',
      PASSWORD_MISMATCH: 'Паролі не збігаються.',
      INVALID_PASSWORD:
        'Довжина пароля повинна бути від {{minLength}} до {{maxLength}} символів. Дозволені лише A-Z, a-z, 0-9 та спеціальні символи.',
      INVALID_EMAIL_OR_PASSWORD: 'Невірна пошта або пароль',
      FIELD_BETWEEN: 'Довжина повинна бути від {{minLength}} до {{maxLength}} символів.',
      PASS_MISMATCH: 'Паролі не збігаються',
      VALUE_MUST_BE_BETWEEN: 'Значення має бути між {{min}} та {{max}}',
      LOADING_ERROR: 'Помилка завантаження',
      NOT_ENOUGH_TOKENS: 'У вас недостатньо токенів для генерації зображення. Будь ласка, поповніть свій акаунт.',
      NO_ITEMS_AVAILABLE: 'Немає доступних елементів',
    },
    MONTH: {
      JANUARY: 'Січень',
      FEBRUARY: 'Лютий',
      MARCH: 'Березень',
      APRIL: 'Квітень',
      MAY: 'Травень',
      JUNE: 'Червень',
      JULY: 'Липень',
      AUGUST: 'Серпень',
      SEPTEMBER: 'Вересень',
      OCTOBER: 'Жовтень',
      NOVEMBER: 'Листопад',
      DECEMBER: 'Грудень',
    },
    WEEK: {
      MONDAY: 'Пн',
      TUESDAY: 'Вт',
      WEDNESDAY: 'Ср',
      THURSDAY: 'Чт',
      FRIDAY: 'Пт',
      SATURDAY: 'Сб',
      SUNDAY: 'Нд',
    },
  },
  FAQ: {
    TOPIC1: {
      QUESTION: 'Як працює зміна плану підписки?',
      ANSWER:
        'Зміна плану підписки доступна в будь-який момент: При переході на вищий рівень — активація відбувається одразу після оплати різниці за час, що залишився. При переході на нижчий — активація відбудеться після закінчення поточного періоду.',
    },
    TOPIC2: {
      QUESTION: 'Чи згоряє бонусна енергія після закінчення підписки?',
      ANSWER:
        'Ні, бонусна енергія не згоряє — ви можете продовжувати використовувати її навіть після закінчення підписки. Коли ви оформите нову підписку, вам буде нарахована нова порція бонусної енергії.',
    },
    TOPIC3: {
      QUESTION: 'Чи продовжується підписка автоматично?',
      ANSWER:
        'Так, підписка продовжується автоматично для вашої зручності, щоб ви не втрачали доступ до функцій. Але ви можете скасувати автопродовження в будь-який момент через налаштування. При цьому доступ до можливостей підписки збережеться до кінця оплаченого періоду.',
    },
    TOPIC4: {
      QUESTION: 'Залишились ще питання?',
      ANSWER: 'Якщо вам потрібна допомога, звертайтесь до нашої служби підтримки.',
      BUTTON: 'Задати питання',
    },
  },
  FAQ_PROFILE: {
    TOPIC1: {
      QUESTION: 'Чи можу я оновити або знизити свій тарифний план?',
      ANSWER:
        'Текст буде доступний найближчим часом. Якщо у вас виникли запитання, будь ласка, зв’яжіться з нами за адресою support@caichat.ai',
    },
    TOPIC2: {
      QUESTION: 'Як скасувати мій тарифний план?',
      ANSWER:
        'Текст буде доступний найближчим часом. Якщо у вас виникли запитання, будь ласка, зв’яжіться з нами за адресою support@caichat.ai',
    },
    TOPIC3: {
      QUESTION: 'Чи можу я скасувати підписку та зберегти переваги плану до кінця поточного розрахункового циклу?',
      ANSWER:
        'Текст буде доступний найближчим часом. Якщо у вас виникли запитання, будь ласка, зв’яжіться з нами за адресою support@caichat.ai',
    },
    TOPIC4: {
      QUESTION: 'Як отримати відшкодування?',
      ANSWER:
        'Текст буде доступний найближчим часом. Якщо у вас виникли запитання, будь ласка, зв’яжіться з нами за адресою support@caichat.ai',
    },
    TOPIC5: {
      QUESTION: 'У мене є додаткові запитання.',
      ANSWER: 'Якщо вам потрібна допомога, натисніть кнопку нижче. Наша служба підтримки завжди готова відповісти на ваші запитання.',
      BUTTON: 'Задати питання',
    },
  },
  BACKEND_MESSAGES: {
    INVALID_PASSWORD: 'Невірний пароль',
    SLUG_ALREADY_TAKEN: 'Slug {{ slug }} вже зайнятий іншим користувачем',
    TOKENS_EXCEEDED:
      'Обрана модель недоступна для цього персонажа. Безкоштовні моделі заблоковані для цього персонажа. Загальний контекст ({{number}} токенів) перевищує ліміт (5000). Будь ласка, використовуйте платну модель.',
    NOT_ENOUGH_TOKENS: 'У вас недостатньо токенів, щоб згенерувати це зображення',
  },
};
